/* Wild Sage by Rosemary — motion.js
   Presentation only. If this file never loads, the store is unchanged. */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  // Tells the stylesheet it is safe to hide things before revealing them.
  document.documentElement.classList.add('js');

  /* ---------- scroll progress ---------- */
  var bar = document.createElement('div');
  bar.className = 'progress';
  document.body.appendChild(bar);

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.transform = 'scaleX(' + (h > 0 ? window.scrollY / h : 0) + ')';
      if (!reduce) parallax();
      ticking = false;
    });
  }

  /* ---------- hero parallax ---------- */
  var heroMedia = $('.hero__media');
  var heroImg = heroMedia && heroMedia.querySelector('img');
  var heroContent = $('.hero__content');
  function parallax() {
    if (!heroMedia) return;
    var y = window.scrollY;
    if (y > window.innerHeight * 1.2) return;
    heroMedia.style.transform = 'translate3d(0,' + (y * 0.22).toFixed(1) + 'px,0)';
    if (heroImg) heroImg.style.transform = 'scale(' + (1.06 + y * 0.00012).toFixed(4) + ')';
    if (heroContent) {
      heroContent.style.transform = 'translate3d(0,' + (y * -0.06).toFixed(1) + 'px,0)';
      heroContent.style.opacity = Math.max(0, 1 - y / (window.innerHeight * 0.85)).toFixed(3);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- staggered reveals + step activation + count-up ---------- */
  if ('IntersectionObserver' in window) {
    // stagger siblings so a grid arrives in sequence rather than all at once
    $$('.grid, .process, .names, .quotes, .look, .tiles, .stats').forEach(function (group) {
      $$('.reveal, .process__step', group).forEach(function (el, i) {
        el.style.setProperty('--d', Math.min(i * 70, 420) + 'ms');
      });
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        if (en.target.hasAttribute('data-count')) countUp(en.target);
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    $$('.reveal, .process__step, [data-count]').forEach(function (el) { io.observe(el); });

    // Anything still hidden after the page settles (printing, a stalled
    // observer, an instant jump to an anchor) is shown rather than left blank.
    setTimeout(function () {
      $$('.reveal:not(.is-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 1.5) el.classList.add('is-in');
      });
    }, 2500);
  } else {
    $$('.reveal, .process__step').forEach(function (el) { el.classList.add('is-in'); });
  }

  function countUp(el) {
    var raw = (el.textContent || '').trim();
    var m = raw.match(/^(\D*)(\d[\d,]*)(.*)$/);
    if (!m || reduce) return;
    var pre = m[1], post = m[3];
    var target = parseInt(m[2].replace(/,/g, ''), 10);
    if (!isFinite(target) || target === 0) return;
    var start = performance.now(), dur = 1100;
    (function step(now) {
      var t = Math.min(1, (now - start) / dur);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = pre + Math.round(target * eased).toLocaleString() + post;
      if (t < 1) requestAnimationFrame(step);
    })(start);
  }

  /* ---------- 3D tilt on product cards ---------- */
  if (fine && !reduce) {
    $$('.card').forEach(function (card) {
      var media = $('.card__media', card);
      if (!media) return;
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        media.style.transform =
          'rotateY(' + (px * 7).toFixed(2) + 'deg) rotateX(' + (-py * 7).toFixed(2) + 'deg) translateZ(0)';
      });
      card.addEventListener('pointerleave', function () { media.style.transform = ''; });
    });
  }

  /* ---------- product gallery lightbox ---------- */
  var main = $('[data-gallery-main]');
  if (main) {
    var lb = document.createElement('div');
    lb.className = 'lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML =
      '<button class="lightbox__close" type="button" aria-label="Close">' +
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<img alt="">';
    document.body.appendChild(lb);
    var lbImg = lb.querySelector('img');

    function open() {
      lbImg.src = main.currentSrc || main.src;
      lbImg.alt = main.alt || '';
      lbImg.classList.remove('is-zoomed');
      lb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      lb.querySelector('.lightbox__close').focus();
    }
    function close() {
      lb.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    main.addEventListener('click', open);
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.closest('.lightbox__close')) close();
    });
    lbImg.addEventListener('click', function (e) {
      e.stopPropagation();
      lbImg.classList.toggle('is-zoomed');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lb.classList.contains('is-open')) close();
    });
  }
})();
